import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import GetAppIcon from '@mui/icons-material/GetApp';

import UserService from "services/UserService";
import axios from "axios";
import { getVirtualSensors } from "services/ConfigServices";
import { virtualsensortext } from "variables/MBM/virtualsensor";
import moment from "moment";

import { downloadCSV } from "utilities/exporttabletocsv";
import Button from "components/CustomButtons/Button.js";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import AddVirtualSensor from "./AddVirtualSensor";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useVirtualSensorsTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const currentusertype = localStorage.getItem('userType');
  const mbm_admin = permis.includes("mbm_admin");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getVirtualSensors(chartIdGroup);
  const [results, setResults] = useState({ meters: [] });
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [virtualsensorsData, setVirtualsensorsData] = useState([]);
  const [virtualsensors, setVirtualsensors] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );

        setResults(response.data);
        setVirtualsensorsData(response.data.virtualsensors);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `virtualsensors`, []).filter(
    (item) =>
      (item.id && (""+item.id).toLowerCase().includes(filterText.toLowerCase())) ||
      (item.name && item.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.groupid && groupInfoListById["" + item.groupid] && groupInfoListById["" + item.groupid].toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = virtualsensors.map((item) => {
      let virtualsensorexport = {};
      virtualsensorexport[virtualsensortext.id] = item.id;
      virtualsensorexport[virtualsensortext.name] = item.name;
      virtualsensorexport[virtualsensortext.frequency] = item.frequency;
      virtualsensorexport[virtualsensortext.group] = groupInfoListById["" + item.groupid];
      virtualsensorexport[virtualsensortext.formula] = item.formula;
      virtualsensorexport[virtualsensortext.lastrun] = (item.lastrun && moment(item.lastrun).isValid()) ? moment(item.lastrun).format("DD/MM/YYYY hh:mm:ss") : "";
      virtualsensorexport[virtualsensortext.lastvalue] = item.lastvalue || "";
      return virtualsensorexport;
    });
    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {mbm_admin && (
          <>
            <UploadButton type="button" onClick={handleClear}>
              <AddVirtualSensor refetch={refreshTable} onClick={handleClear} />
            </UploadButton>
          </>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!virtualsensors || virtualsensors.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, virtualsensorsData, virtualsensors]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setVirtualsensors
  };
}
